import type { ReactNode } from "react";

import { cn } from "@/lib/cn";

interface Props {
  title: string;
  message: string;
  icon?: ReactNode;
  className?: string;
}

export function PlaceholderState({ title, message, icon, className }: Props) {
  return (
    <div
      className={cn(
        "rounded-card border border-line bg-cream/60 p-6 text-center",
        className,
      )}
    >
      {icon ? (
        <div className="mb-3 flex justify-center text-masjidGreen/80">{icon}</div>
      ) : null}
      <h3 className="font-serif text-lg text-ink">{title}</h3>
      <p className="mt-2 text-sm leading-relaxed text-muted">{message}</p>
    </div>
  );
}
